var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "not_found" },
    [
      _c("WebViewHeader", {
        attrs: { "is-show-close-btn": true, "is-show-back-btn": false },
      }),
      _vm._m(0),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("section", [
      _c("img", {
        attrs: {
          src: require("@/assets/images/hissam/img_fail2.png"),
          alt: "아이콘",
        },
      }),
      _c("h2", [_vm._v("찾을 수 없는 페이지입니다.")]),
      _c("p", [
        _vm._v("요청하신 페이지가 변경, 삭제되었거나"),
        _c("br"),
        _vm._v("잘못된 경로를 입력하셨습니다."),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }